const User = () => {
    return (
        <div className="user-card">
            <h3>Name: Hari</h3>
            <h3>Location: Bangalore</h3>
            <h3>Contact: hari@gmail.com</h3>
        </div>
    )
};

export default User;